export default __webpack_public_path__ + "static/media/calendar-dates.a99d7480.svg";